export default "__VITE_ASSET__BP4rMRLR__"